<div class="main">
    <div class="section">
        <div class="container">
            <div class="row">
                <div class="col-md-12 ml-auto mr-auto text-center">
                    <h2 class="title">Get a Quote</h2>
                </div>
            </div>
            <div class="row">


                <div class="col-md-4 ml-auto mr-auto text-center d-none d-sm-none d-md-block">

                    <p>
                        Answer a few simple questions to see how easy it is to launch the eMD Software in your medical
                        practice.
                    </p>

                    <img class="img img-container" src="./assets/img/website_2/image_14.png" />
                </div>


                <div class="col-sm-12 col-md-7 ml-auto mr-auto text-center">


                    <div class="card card-package" data-color="default">
                        <div class="card-body">


                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="title mt-n1"><small>Practice Information</small></h3>
                                    <form [formGroup]="getAQuoteForm" class="contact">

                                        <input formControlName="website" type="text" autocomplete="off" tabindex="-1"
                                            aria-hidden="true"
                                            style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;">



                                        <div class="row">
                                            <div class="col-md-6">

                                                <input formControlName="first_name" type="text" class="form-control"
                                                    placeholder="First Name"><small
                                                    *ngIf="f['first_name'].errors && f['first_name'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>
                                            </div>
                                            <div class="col-md-6">

                                                <input formControlName="last_name" type="text" class="form-control"
                                                    placeholder="Last Name"> <small
                                                    *ngIf="f['last_name'].errors && f['last_name'].errors.required"
                                                    class="text-danger form-text text-muted mr-auto text-right mt-n3">*Required!</small>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">

                                                <input formControlName="email" type="text" class="form-control"
                                                    placeholder="Email"> <small
                                                    *ngIf="f['email'].errors && f['email'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>
                                            </div>
                                            <div class="col-md-6">

                                                <input formControlName="mobile" type="text" class="form-control"
                                                    placeholder="Mobile"> <small
                                                    *ngIf="f['mobile'].errors && f['mobile'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>
                                            </div>
                                        </div>



                                        <div class="row align-items-center mb-2">
                                            <div class="col-md-6">
                                                Practice Number<input formControlName="practice_number" type="text"
                                                    class="form-control" placeholder="Practice Number"><small
                                                    *ngIf="f['practice_number'].errors && f['practice_number'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>

                                            </div>

                                            <div class="col-md-6">

                                                Region <select formControlName="selected_region"
                                                    class="dropdown w-100 form-control" id="selected_region">
                                                    <option value="Eastern Cape">
                                                        Eastern Cape</option>
                                                    <option value="Free State">
                                                        Free State</option>
                                                    <option value="Gauteng">
                                                        Gauteng</option>
                                                    <option value="KwaZulu-Natal">
                                                        KwaZulu-Natal</option>
                                                    <option value="Limpopo">
                                                        Limpopo</option>
                                                    <option value="Mpumalanga">
                                                        Mpumalanga</option>
                                                    <option value="Northern Cape">
                                                        Northern Cape</option>
                                                    <option value="North West">
                                                        North West</option>
                                                    <option value="Western Cape">
                                                        Western Cape</option>

                                                </select> <small
                                                    *ngIf="f['selected_region'].errors && f['selected_region'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>

                                            </div>


                                        </div>


                                        <ng-container *ngIf="isNedbankLead">
                                            <h3 class="title mt-n1"><small>Nedbank Information</small></h3>
                                            <div class="row align-items-center mb-2">
                                                <div class="col-md-6">
                                                    <div class="form-check">
                                                        <label class="form-check-label">
                                                            <input class="form-check-input" type="checkbox"
                                                                formControlName="is_existing_nedbank_client">
                                                            Existing Nedbank Client
                                                            <span class="form-check-sign"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">

                                                    Banker Email <input formControlName="banker_email"
                                                        type="email" class="form-control"
                                                        placeholder="Banker Email"><small
                                                        *ngIf="f['banker_email'].errors && f['banker_email'].errors.required"
                                                        class="text-danger form-text text-muted text-right mt-n3">*Required!</small><small
                                                        *ngIf="f['banker_email'].errors && f['banker_email'].errors.email"
                                                        class="text-danger form-text text-muted text-right mt-n3">*Invalid email!</small>
                                                </div>
                                            </div>
                                        </ng-container>


                                        <h3 class="title mt-n1"><small>Claims Information</small></h3>




                                        <div class="row align-items-center mb-2">


                                            <div class="col-md-6">

                                                Speciality <select formControlName="practitioner_speciality"
                                                    class="dropdown w-100 form-control" id="practitioner_speciality">
                                                    <option value="Ambulance Services :  Basic Life Support"> Ambulance Services :  Basic Life Support</option>
                                                    <option value="Ambulance Services :  Intermediate Life Support"> Ambulance Services :  Intermediate Life Support</option>
                                                    <option value="Ambulance Services : Advanced Life Support"> Ambulance Services : Advanced Life Support</option>
                                                    <option value="Anaesthetist"> Anaesthetist</option>
                                                    <option value="Anatomical Pathologist"> Anatomical Pathologist</option>
                                                    <option value="Arts Therapy"> Arts Therapy</option>
                                                    <option value="Audiologist"> Audiologist</option>
                                                    <option value="Biokineticist"> Biokineticist</option>
                                                    <option value="Cardio Thoracic Surgeon"> Cardio Thoracic Surgeon</option>
                                                    <option value="Cardiologist"> Cardiologist</option>
                                                    <option value="Chiropractor"> Chiropractor</option>
                                                    <option value="Clinical Haematology"> Clinical Haematology</option>
                                                    <option value="Clinical Pathologist"> Clinical Pathologist</option>
                                                    <option value="Clinical Services"> Clinical Services</option>
                                                    <option value="Clinical Technologists"> Clinical Technologists</option>
                                                    <option value="Community Dentist"> Community Dentist</option>
                                                    <option value="Community Health"> Community Health</option>
                                                    <option value="Day clinics (76)"> Day clinics (76)</option>
                                                    <option value="Day clinics : Private (77)"> Day clinics : Private (77)</option>
                                                    <option value="Dental Technologist"> Dental Technologist</option>
                                                    <option value="Dental Therapist"> Dental Therapist</option>
                                                    <option value="Dermatologist"> Dermatologist</option>
                                                    <option value="Dietician"> Dietician</option>
                                                    <option value="Drug and Alcohol Rehab"> Drug and Alcohol Rehab</option>
                                                    <option value="Emergency Medicine Independent Practice Specialist"> Emergency Medicine Independent Practice Specialist</option>
                                                    <option value="Frail Care Centre"> Frail Care Centre</option>
                                                    <option value="Gastroenterologist"> Gastroenterologist</option>
                                                    <option value="General Dental Practitioner"> General Dental Practitioner</option>
                                                    <option value="GP Anaesthetic"> GP Anaesthetic</option>
                                                    <option value="GP"> GP</option>
                                                    <option value="Gynaecologist"> Gynaecologist</option>
                                                    <option value="Hearing Aid Acoustician"> Hearing Aid Acoustician</option>
                                                    <option value="Homeopath"> Homeopath</option>
                                                    <option value="Hospices"> Hospices</option>
                                                    <option value="Maxillo-facial and Oral Surgeon"> Maxillo-facial and Oral Surgeon</option>
                                                    <option value="Medical Aid"> Medical Aid</option>
                                                    <option value="Medical Oncologist"> Medical Oncologist</option>
                                                    <option value="Medical Orthotists &amp; Prosthetists"> Medical Orthotists &amp; Prosthetists</option>
                                                    <option value="Medical Scientist"> Medical Scientist</option>
                                                    <option value="Medical Technologist"> Medical Technologist</option>
                                                    <option value="Neurologist"> Neurologist</option>
                                                    <option value="Neurosurgeon"> Neurosurgeon</option>
                                                    <option value="Nuclear Medicine"> Nuclear Medicine</option>
                                                    <option value="Nursing Agency"> Nursing Agency</option>
                                                    <option value="Occupational Therapist"> Occupational Therapist</option>
                                                    <option value="Opthalmologist"> Opthalmologist</option>
                                                    <option value="Optometrist"> Optometrist</option>
                                                    <option value="Oral Hygienist"> Oral Hygienist</option>
                                                    <option value="Oral Pathologist"> Oral Pathologist</option>
                                                    <option value="Orthodontist"> Orthodontist</option>
                                                    <option value="Orthopaedic"> Orthopaedic</option>
                                                    <option value="Orthoptist"> Orthoptist</option>
                                                    <option value="Other"> Other</option>
                                                    <option value="Otorhinolaryngologist(ENT)"> Otorhinolaryngologist(ENT)</option>
                                                    <option value="Paediatric Cardiologist"> Paediatric Cardiologist</option>
                                                    <option value="Paediatrician"> Paediatrician</option>
                                                    <option value="Periodontist"> Periodontist</option>
                                                    <option value="Pharmacy"> Pharmacy</option>
                                                    <option value="Physical Medicine"> Physical Medicine</option>
                                                    <option value="Physical Rehabilitation Hospitals"> Physical Rehabilitation Hospitals</option>
                                                    <option value="Physician"> Physician</option>
                                                    <option value="Physiotherapist"> Physiotherapist</option>
                                                    <option value="Plastic Surgeon"> Plastic Surgeon</option>
                                                    <option value="Podiatrist"> Podiatrist</option>
                                                    <option value="Private Hospital A"> Private Hospital A</option>
                                                    <option value="Private Hospital"> Private Hospital</option>
                                                    <option value="Prosthodontist"> Prosthodontist</option>
                                                    <option value="Psychiatric Sister"> Psychiatric Sister</option>
                                                    <option value="Psychiatrist"> Psychiatrist</option>
                                                    <option value="Psychologist"> Psychologist</option>
                                                    <option value="Psychometry"> Psychometry</option>
                                                    <option value="Pulmonologist"> Pulmonologist</option>
                                                    <option value="Radiation Oncologist"> Radiation Oncologist</option>
                                                    <option value="Radiographer"> Radiographer</option>
                                                    <option value="Radiologist"> Radiologist</option>
                                                    <option value="Registered Counsellor"> Registered Counsellor</option>
                                                    <option value="Registered Nurse"> Registered Nurse</option>
                                                    <option value="Representative"> Representative</option>
                                                    <option value="Rheumatology"> Rheumatology</option>
                                                    <option value="Social Worker"> Social Worker</option>
                                                    <option value="Specialist Family Practice"> Specialist Family Practice</option>
                                                    <option value="Specialist Radiologist"> Specialist Radiologist</option>
                                                    <option value="Speech Therapist &amp; Audiologist"> Speech Therapist &amp; Audiologist</option>
                                                    <option value="Speech Therapist"> Speech Therapist</option>
                                                    <option value="Sub Acute Facility"> Sub Acute Facility</option>
                                                    <option value="Supplier"> Supplier</option>
                                                    <option value="Surgeon"> Surgeon</option>
                                                    <option value="Thoracic Surgeon"> Thoracic Surgeon</option>
                                                    <option value="Unani-Tibb"> Unani-Tibb</option>
                                                    <option value="Urologist"> Urologist</option>

                                                    <small
                                                        *ngIf="f['practitioner_speciality'].errors && f['practitioner_speciality'].errors.required"
                                                        class="text-danger form-text text-muted text-right mt-n3">*Required!</small>

                                                </select>

                                            </div>



                                            <div class="col-md-6">

                                                Package Interested <select formControlName="interested_package"
                                                    class="dropdown w-100 form-control" id="interested_package">
                                                    <option value="diy-starter">
                                                        DIY Starter</option>
                                                    <option value="diy">
                                                        DIY</option>
                                                    <option value="full-house">
                                                        Full House</option>
                                                    <option value="e-buro">
                                                        e-Buro</option>

                                                </select>
                                                <small
                                                    *ngIf="f['interested_package'].errors && f['interested_package'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>
                                            </div>


                                        </div>

                                        <div class="row">
                                            <div class="col-md-6">

                                                Number of Visits (per month)<input formControlName="number_of_visits"
                                                    type="number" class="form-control" placeholder=""> <small
                                                    *ngIf="f['number_of_visits'].errors && f['number_of_visits'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>
                                            </div>
                                            <div class="col-md-6">

                                                Average Claim Value per Visit (R) <input
                                                    formControlName="average_claim_per_visit" type="number"
                                                    class="form-control" placeholder=""> <small
                                                    *ngIf="f['average_claim_per_visit'].errors && f['average_claim_per_visit'].errors.required"
                                                    class="text-danger form-text text-muted text-right mt-n3">*Required!</small>
                                            </div>
                                        </div>


                                        <textarea formControlName="message" class="form-control"
                                            placeholder="If you have any additional information or requests, please feel free to share them."
                                            rows="9"></textarea>

                                        <div class="row">
                                            <div class="col-md-6 ml-auto mr-auto">

                                                <div *ngIf="getAQuoteForm.valid == true">

                                                    <button (click)="open(classic, '')"
                                                        class="btn btn-primary btn-block btn-round">Submit
                                                    </button>

                                                </div>

                                                <div *ngIf="getAQuoteForm.valid == false">

                                                    <button disabled class="btn btn-primary btn-block btn-round">Submit
                                                    </button>

                                                </div>


                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>


            </div>








            <ng-template #classic let-c="close" let-d="dismiss">
                <ng-container *ngIf="submitState === 'pending'">
                    <div class="modal-body text-center py-4">
                        <div class="spinner-border text-primary mb-3" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <p class="mb-0">Submitting your request&hellip;</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="submitState === 'success'">
                    <div class="modal-header">
                        <h5 class="modal-title text-center">Email Sent!</h5>
                        <button type="button" class="close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Thank you, a email have been sent to relevant parties and we will contact you shortly.
                    </div>
                    <div class="modal-footer">
                        <div class="divider"></div>
                        <div class="right-side">
                            <button type="button" class="btn btn-success btn-link" (click)="c('Close click')">Ok</button>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="submitState === 'error'">
                    <div class="modal-header">
                        <h5 class="modal-title text-center text-danger">Submission failed</h5>
                        <button type="button" class="close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        We couldn't submit your request. Please check your connection and try again, or contact us directly.
                    </div>
                    <div class="modal-footer">
                        <div class="divider"></div>
                        <div class="right-side">
                            <button type="button" class="btn btn-danger btn-link" (click)="c('Close click')">Close</button>
                        </div>
                    </div>
                </ng-container>
            </ng-template>

        </div>
    </div>
</div>